import AppFieldCard from "elements/AppFieldCard";
import RequiredTitle from "elements/RequiredTitle";
import { CheckPicker } from "rsuite";
import useHeadersPickerData from "./useHeadersPickerData";

const MatchRecordsConfig = ({
  mappedHeaders, // The selected fields(headers) with their associated data identifier.
  fieldMap, // Field map with key: Field.APIName, value: Field.Name
  matchAction, // The match action. "update" or "skip"
  onUpdateAction, // Callback function to update matchAction
  matchFields, // The selected match fields (Array of Field.APINames)
  onMatchFieldsChange, // Callback function for when matchFields are updated
}) => {
  const pickerData = useHeadersPickerData({ fieldMap, mappedHeaders });

  return (
    <>
      <RequiredTitle
        size="md"
        title="Find Existing Records By:"
        titleCSS="mb-0"
      />
      <small>
        Select the field/column you'd like to match existing records by.
      </small>
      <CheckPicker
        className="mt-2 mb-4"
        data={pickerData}
        labelKey={"Name"}
        valueKey={"APIName"}
        value={matchFields}
        onChange={onMatchFieldsChange}
        renderMenuItem={(label) => "By " + label}
        block
        preventOverflow
      />
      <RequiredTitle size="md" title="Action:" titleCSS="mb-0" />
      <div className="mb-2">
        <small>Perform the following action when a match is found.</small>
      </div>
      <div className="mt-3 mb-5">
        <AppFieldCard
          onClick={() => onUpdateAction("update")}
          isSelected={matchAction === "update"}
          name="Update Record With Data"
          description="When an existing record is found, update the record with the data."
          icon="swap-horizontal"
          css="mb-2"
          full
        />
        <AppFieldCard
          onClick={() => onUpdateAction("skip")}
          isSelected={matchAction === "skip"}
          name="Skip Record"
          description="When an existing record is found, don't update the record"
          icon="skip-forward"
          full
        />
      </div>
    </>
  );
};

export default MatchRecordsConfig;
